/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveDownLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M11 19H5V13" }],
    ["path", { d: "M19 5L5 19" }]
  ]
];

export { MoveDownLeft as default };
//# sourceMappingURL=move-down-left.js.map
